import { isPreProductionEnvironment } from "utils/env";

export const STATUS_PAGE_URL = isPreProductionEnvironment()
  ? "https://spacelift-preprod.statuspage.io"
  : "https://spacelift.statuspage.io";

export const UPCOMING_MAINTENANCE_URL = `${STATUS_PAGE_URL}/api/v2/scheduled-maintenances/upcoming.json`;

export const ADVANCE_NOTICE_DAYS = 14;
